import { c as _c } from "react/compiler-runtime";
import { CollectionLockup, CollectionLockupContent, CollectionLockupTitle } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { FlexColumn, NumberDisplay, SkeletonBlock, SkeletonLine } from "@opensea/ui-kit";
import { bn } from "@opensea/utils";
import { useTranslations } from "use-intl";
import { ProfileCollectionItemFragment } from "./ProfileCollectionItem.fragment";
import { ProfileCollectionListItem as ListItem, ProfileCollectionListItemAvatar, ProfileCollectionListItemContent, ProfileCollectionListItemDescription, ProfileCollectionListItemSide, ProfileCollectionListItemTitle } from "./ProfileCollectionListItem";
export const ProfileCollectionItem = t0 => {
  const $ = _c(35);
  const {
    collection: collectionKey,
    itemCount
  } = t0;
  const t = useTranslations("wallet.ProfileCollectionItem");
  let t1;
  if ($[0] !== collectionKey) {
    t1 = readFragment(ProfileCollectionItemFragment, collectionKey);
    $[0] = collectionKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const profileCollection = t1;
  let t2;
  if ($[2] !== profileCollection.slug) {
    t2 = {
      pathname: "/profile",
      query: {
        collectionSlugs: profileCollection.slug
      }
    };
    $[2] = profileCollection.slug;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = profileCollection.imageUrl ?? "";
  let t4;
  if ($[4] !== t3) {
    t4 = <ProfileCollectionListItemAvatar className="inset-shadow-border rounded" size={42} src={t3} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CollectionLockupContent><CollectionLockupTitle /></CollectionLockupContent>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== profileCollection) {
    t6 = <CollectionLockup collection={profileCollection}>{t5}</CollectionLockup>;
    $[7] = profileCollection;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== profileCollection.floorPrice || $[10] !== t) {
    t7 = profileCollection.floorPrice && <ProfileCollectionListItemDescription>{t("floor")} <NumberDisplay suffix={profileCollection.floorPrice.pricePerItem.token.symbol} value={profileCollection.floorPrice.pricePerItem.token.unit} /></ProfileCollectionListItemDescription>;
    $[9] = profileCollection.floorPrice;
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <ProfileCollectionListItemContent>{t6}{t7}</ProfileCollectionListItemContent>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== itemCount || $[16] !== profileCollection.topOffer) {
    t9 = profileCollection.topOffer ? bn(profileCollection.topOffer.pricePerItem.usd).multipliedBy(itemCount) : undefined;
    $[15] = itemCount;
    $[16] = profileCollection.topOffer;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <ProfileCollectionListItemTitle><NumberDisplay display="usd" value={t9} /></ProfileCollectionListItemTitle>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = profileCollection.topOffer?.pricePerItem.token.symbol;
  let t12;
  if ($[20] !== itemCount || $[21] !== profileCollection.topOffer) {
    t12 = profileCollection.topOffer ? bn(profileCollection.topOffer.pricePerItem.token.unit).multipliedBy(itemCount) : undefined;
    $[20] = itemCount;
    $[21] = profileCollection.topOffer;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t11 || $[24] !== t12) {
    t13 = <ProfileCollectionListItemDescription><NumberDisplay suffix={t11} value={t12} /></ProfileCollectionListItemDescription>;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t10 || $[27] !== t13) {
    t14 = <ProfileCollectionListItemSide className="items-end">{t10}{t13}</ProfileCollectionListItemSide>;
    $[26] = t10;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== profileCollection.slug || $[30] !== t14 || $[31] !== t2 || $[32] !== t4 || $[33] !== t8) {
    t15 = <ListItem className="mb-0.5 p-2" href={t2} interactive={true} key={profileCollection.slug}>{t4}{t8}{t14}</ListItem>;
    $[29] = profileCollection.slug;
    $[30] = t14;
    $[31] = t2;
    $[32] = t4;
    $[33] = t8;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
};
export const ProfileCollectionItemSkeleton = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SkeletonBlock className="inset-shadow-border size-12 rounded" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ProfileCollectionListItemContent><FlexColumn className="h-9 gap-2"><SkeletonLine className="h-4 w-[120px]" /><SkeletonLine className="h-3 w-[100px]" /></FlexColumn></ProfileCollectionListItemContent>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ListItem className="px-0">{t0}{t1}<ProfileCollectionListItemSide><FlexColumn className="h-9 items-end gap-2"><SkeletonLine className="h-4 w-[120px]" /><SkeletonLine className="h-3 w-[100px]" /></FlexColumn></ProfileCollectionListItemSide></ListItem>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};